import { useEffect, useState } from "react"
import { useQuery } from "urql"

import type { Role, RolesListQuery, RolesListQueryVariables } from "@/graphql/codegen/graphql"
import { RolesListDocument } from "@/graphql/codegen/graphql"

interface UseInstructionFileUploadReturn {
  roles: Role[]
  fetching: boolean
  loadMore: () => void
}

const LIMIT = 20

export const useGetRoles = ({ query }: { query?: string }): UseInstructionFileUploadReturn => {
  const [offset, setOffset] = useState(0)
  const [supplierList, setSupplierList] = useState<Role[]>([])

  const [{ data, fetching }] = useQuery<RolesListQuery, RolesListQueryVariables>({
    query: RolesListDocument,
    variables: {
      input: {
        filter: { ...(query && query?.length > 1 && { query }) },
      },
    },
  })

  useEffect(() => {
    setOffset(0)
  }, [query])

  useEffect(() => {
    if (!data) return

    const roles = data?.role?.list?.__typename === "RoleListSuccess" ? (data?.role?.list?.roles as Role[]) : []

    setSupplierList((prev) => {
      const uniqueIds = new Set(prev.map((role) => role.roleId))
      return offset === 0 ? roles : [...prev, ...roles.filter((role) => !uniqueIds.has(role.roleId))]
    })
  }, [data, offset])

  const loadMore = () => {
    setOffset((prevOffset) => prevOffset + LIMIT)
  }

  return {
    roles: supplierList,
    fetching,
    loadMore,
  }
}
